export default __webpack_public_path__ + "static/media/logo2.bd3f9cb9.jpg";